<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="演出ID" :value="1"></el-option>
                            <el-option label="演出名称" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>               
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择" size="small">
                        <el-option label="待审核" :value="0"></el-option>
                        <el-option label="已通过" :value="1"></el-option>
                        <el-option label="已拒绝" :value="2"></el-option>
						<!-- <el-option label="已还原" :value="3"></el-option> -->
						<el-option label="不限制状态" value=""></el-option>
                    </el-select>
                </el-col>                
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
           <el-button v-if="$utils.have('/activityOrder/batchCancel/batchAudit')" type="primary" size="small" @click="batchPass()">一键通过</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
				<el-table-column prop="status" label="状态">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 0">待审核</span>
						<span v-else-if="scope.row.status == 1" class="color-success">已通过</span>
						<span v-else-if="scope.row.status == 2" class="color-danger">已拒绝</span>
						<!-- <span v-else-if="scope.row.status == 3" class="color-danger">已还原</span>	 -->	
					</template>
				</el-table-column>
                <el-table-column prop="cancelNum" label="取消订单数" min-width="100"></el-table-column>
				<el-table-column prop="isCalculateRefundFee" label="扣除手续费">
					<template slot-scope="scope">
						<span v-if="scope.row.isCalculateRefundFee == 1">是</span>						
						<span v-else-if="scope.row.isCalculateRefundFee == 0">否</span>
					</template>
				</el-table-column>				
				<el-table-column prop="activityId" label="演出ID"></el-table-column>
				<el-table-column prop="activityName" label="演出名称" show-overflow-tooltip min-width="250">
				    <template slot-scope="scope">
				        <el-link class="ellipsis" :href="`${sswap}/pages/activity/detail/detail?activityId=${scope.row.activityId}`" target="_blank">{{scope.row.activityName}}</el-link>
				    </template>
				</el-table-column>
				<el-table-column prop="reason" label="取消原由" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createUserName" label="申请人" min-width="120"></el-table-column>
				<el-table-column prop="createTime" label="申请时间" min-width="150"></el-table-column>
				<!-- <el-table-column prop="auditUserName" label="审核人" min-width="120"></el-table-column>
				<el-table-column prop="auditTime" label="审核时间" min-width="150"></el-table-column> 25547283 -->
                <el-table-column fixed="right" label="操作" width="170">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/activiOrder/detail')"
                            type="text"
                            size="small"                            
                            @click="$refs.orderDetails.show(scope.row)"
                            >详情</el-button>                        
							<el-link class="link ML20" target="_blank" :href="`/activityManage/order/list?batchCancelId=${scope.row.id}`" type="primary">查看包含订单</el-link> 
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <OrderDetails ref="orderDetails" @onUpdate="getDataList"></OrderDetails>
    </div>
</template>

<script>
import OrderDetails from './components/OrderDetails';
const defaultParams = {
    pageNo:1,
    searchType: 1,
    searchValue: '',
    status: 0,
   
}

export default {
    components:{OrderDetails},
    data(){
        return{
            data: null,
            dataList: null,           
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || '',
                status: parseInt(this.$route.query.status || 0)
            },
            listLoading: true,
            sswap:process.env.VUE_APP_SSWAP_URL,        
        }
    },
    computed:{       
    },
    mounted() {        
        this.getDataList();      
    },
    methods:{
       
        //获取列表
        getDataList() {           
            this.listLoading = true;
            this.params = {
                ...this.params,               
            }
            this.$request({
                url: "/activityOrder/batchCancel/list",
                method: "POST",
                data: this.params ,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];

                    } else {
                        this.data = null;
                        this.dataList = null;
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },		
         //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {            
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };           
            this.getDataList();
        },
		batchPass(){
			if( this.params.status === 0 ){
				this.listLoading = true;
				this.params = {
					...this.params,               
				}
				this.$request({
					url: "/activityOrder/batchCancel/auditCheck",
					method: "POST",
					data: this.params ,
				})
					.then((res) => {
						const { state, msg, result } = res.data;
						if ( state == 1 ) {
								const _msg =  result == 1 ? `<div>注意:当前订单包含<span class="color-danger">实体票订单，且已经发货</span>，确认将当前列表中待审核的取消申请<span class="color-danger">全部通过</span>？</div>` : `<div>会将当前列表中待审核的取消申请<span class="color-danger">全部通过</span><br>是否确认操作？</div>` ;
								
								this.$confirm(_msg, '一键通过', {
									closeOnClickModal: false,
									dangerouslyUseHTMLString: true,
									confirmButtonText: "全部通过",
									cancelButtonText: '取消',
								}).then(() => {
								   
									this.$request({
										url: "/activityOrder/batchCancel/batchAudit",
										method: "POST",
										data:{
											...this.params,
											status:1						
										} 
									})
										.then((res) => {
											const { state, msg, result } = res.data;
											if (state == 1) {			    			
												this.$message.success("操作成功");
												this.getDataList();
												this.listLoading = false
												
											} else {			            
												this.$message.error(msg || "操作失败");						
												this.getDataList();
												this.listLoading = false
												
											}
										})
										.catch(() => {
											this.$message.error("操作错误");
											this.listLoading = false
										})
									
								}).catch(() => {
									this.listLoading = false
								})			   
				
						} else {
						   
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})
					.finally(() => {
						this.listLoading = false;
					});
			}else{
				return this.$message.error("请先筛选查询待审核的订单");
			}
		}
		
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table__row expanded{
    div{
        line-height: 30px;
    }
}

.temp-table{
	margin-top: 20px;
	height: 300px;
	overflow-y:auto;
	::v-deep .el-table,.el-table thead{
		color:#f00
	}
	
	
}
</style>